/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DailyRate } from './';
import {
    DailyRateFromJSON,
    DailyRateFromJSONTyped,
    DailyRateToJSON,
} from './';
import type { Education } from './';
import {
    EducationFromJSON,
    EducationFromJSONTyped,
    EducationToJSON,
} from './';
import type { ExperienceLevelResource } from './';
import {
    ExperienceLevelResourceFromJSON,
    ExperienceLevelResourceFromJSONTyped,
    ExperienceLevelResourceToJSON,
} from './';
import type { FreelancerSignupProfileDraftCategories } from './';
import {
    FreelancerSignupProfileDraftCategoriesFromJSON,
    FreelancerSignupProfileDraftCategoriesFromJSONTyped,
    FreelancerSignupProfileDraftCategoriesToJSON,
} from './';
import type { FreelancingExperience } from './';
import {
    FreelancingExperienceFromJSON,
    FreelancingExperienceFromJSONTyped,
    FreelancingExperienceToJSON,
} from './';
import type { LanguageAndLevel } from './';
import {
    LanguageAndLevelFromJSON,
    LanguageAndLevelFromJSONTyped,
    LanguageAndLevelToJSON,
} from './';
import type { LocationAndWorkplacePreference } from './';
import {
    LocationAndWorkplacePreferenceFromJSON,
    LocationAndWorkplacePreferenceFromJSONTyped,
    LocationAndWorkplacePreferenceToJSON,
} from './';
import type { ProfilePicture } from './';
import {
    ProfilePictureFromJSON,
    ProfilePictureFromJSONTyped,
    ProfilePictureToJSON,
} from './';
import type { StrategyBackground } from './';
import {
    StrategyBackgroundFromJSON,
    StrategyBackgroundFromJSONTyped,
    StrategyBackgroundToJSON,
} from './';
import type { WorkExperience } from './';
import {
    WorkExperienceFromJSON,
    WorkExperienceFromJSONTyped,
    WorkExperienceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerSignupProfileDraft
 */
export interface FreelancerSignupProfileDraft {
    /**
     * 
     * @type {FreelancingExperience}
     * @memberof FreelancerSignupProfileDraft
     */
    freelancingExperience?: FreelancingExperience;
    /**
     * 
     * @type {Array<WorkExperience>}
     * @memberof FreelancerSignupProfileDraft
     */
    workExperiences: Array<WorkExperience>;
    /**
     * 
     * @type {Array<Education>}
     * @memberof FreelancerSignupProfileDraft
     */
    educations: Array<Education>;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupProfileDraft
     */
    headline?: string;
    /**
     * 
     * @type {FreelancerSignupProfileDraftCategories}
     * @memberof FreelancerSignupProfileDraft
     */
    categories?: FreelancerSignupProfileDraftCategories;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupProfileDraft
     */
    otherCategory?: string;
    /**
     * 
     * @type {ExperienceLevelResource}
     * @memberof FreelancerSignupProfileDraft
     */
    experienceLevel?: ExperienceLevelResource;
    /**
     * 
     * @type {Array<LanguageAndLevel>}
     * @memberof FreelancerSignupProfileDraft
     */
    languages: Array<LanguageAndLevel>;
    /**
     * 
     * @type {DailyRate}
     * @memberof FreelancerSignupProfileDraft
     */
    dailyRate?: DailyRate;
    /**
     * 
     * @type {LocationAndWorkplacePreference}
     * @memberof FreelancerSignupProfileDraft
     */
    locationAndWorkplacePreference?: LocationAndWorkplacePreference;
    /**
     * 
     * @type {ProfilePicture}
     * @memberof FreelancerSignupProfileDraft
     */
    profilePicture?: ProfilePicture;
    /**
     * 
     * @type {string}
     * @memberof FreelancerSignupProfileDraft
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerSignupProfileDraft
     */
    globalTopSkills?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerSignupProfileDraft
     */
    privacyOptOut?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerSignupProfileDraft
     */
    globalSkills?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerSignupProfileDraft
     */
    functionalSkillIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancerSignupProfileDraft
     */
    industryExpertiseIds?: Array<string>;
    /**
     * 
     * @type {Array<StrategyBackground>}
     * @memberof FreelancerSignupProfileDraft
     */
    strategyBackgrounds?: Array<StrategyBackground>;
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerSignupProfileDraft
     */
    willingnessToTravelInternationally?: boolean;
}

/**
 * Check if a given object implements the FreelancerSignupProfileDraft interface.
 */
export function instanceOfFreelancerSignupProfileDraft(value: object): value is FreelancerSignupProfileDraft {
    if (!('workExperiences' in value) || value['workExperiences'] === undefined) return false;
    if (!('educations' in value) || value['educations'] === undefined) return false;
    if (!('languages' in value) || value['languages'] === undefined) return false;
    return true;
}

export function FreelancerSignupProfileDraftFromJSON(json: any): FreelancerSignupProfileDraft {
    return FreelancerSignupProfileDraftFromJSONTyped(json, false);
}

export function FreelancerSignupProfileDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerSignupProfileDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancingExperience': json['freelancingExperience'] == null ? undefined : FreelancingExperienceFromJSON(json['freelancingExperience']),
        'workExperiences': ((json['workExperiences'] as Array<any>).map(WorkExperienceFromJSON)),
        'educations': ((json['educations'] as Array<any>).map(EducationFromJSON)),
        'headline': json['headline'] == null ? undefined : json['headline'],
        'categories': json['categories'] == null ? undefined : FreelancerSignupProfileDraftCategoriesFromJSON(json['categories']),
        'otherCategory': json['otherCategory'] == null ? undefined : json['otherCategory'],
        'experienceLevel': json['experienceLevel'] == null ? undefined : ExperienceLevelResourceFromJSON(json['experienceLevel']),
        'languages': ((json['languages'] as Array<any>).map(LanguageAndLevelFromJSON)),
        'dailyRate': json['dailyRate'] == null ? undefined : DailyRateFromJSON(json['dailyRate']),
        'locationAndWorkplacePreference': json['locationAndWorkplacePreference'] == null ? undefined : LocationAndWorkplacePreferenceFromJSON(json['locationAndWorkplacePreference']),
        'profilePicture': json['profilePicture'] == null ? undefined : ProfilePictureFromJSON(json['profilePicture']),
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'globalTopSkills': json['globalTopSkills'] == null ? undefined : json['globalTopSkills'],
        'privacyOptOut': json['privacyOptOut'] == null ? undefined : json['privacyOptOut'],
        'globalSkills': json['globalSkills'] == null ? undefined : json['globalSkills'],
        'functionalSkillIds': json['functionalSkillIds'] == null ? undefined : json['functionalSkillIds'],
        'industryExpertiseIds': json['industryExpertiseIds'] == null ? undefined : json['industryExpertiseIds'],
        'strategyBackgrounds': json['strategyBackgrounds'] == null ? undefined : ((json['strategyBackgrounds'] as Array<any>).map(StrategyBackgroundFromJSON)),
        'willingnessToTravelInternationally': json['willingnessToTravelInternationally'] == null ? undefined : json['willingnessToTravelInternationally'],
    };
}

export function FreelancerSignupProfileDraftToJSON(value?: FreelancerSignupProfileDraft | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancingExperience': FreelancingExperienceToJSON(value['freelancingExperience']),
        'workExperiences': ((value['workExperiences'] as Array<any>).map((v) => WorkExperienceToJSON(v))),
        'educations': ((value['educations'] as Array<any>).map((v) => EducationToJSON(v))),
        'headline': value['headline'],
        'categories': FreelancerSignupProfileDraftCategoriesToJSON(value['categories']),
        'otherCategory': value['otherCategory'],
        'experienceLevel': ExperienceLevelResourceToJSON(value['experienceLevel']),
        'languages': ((value['languages'] as Array<any>).map((v) => LanguageAndLevelToJSON(v))),
        'dailyRate': DailyRateToJSON(value['dailyRate']),
        'locationAndWorkplacePreference': LocationAndWorkplacePreferenceToJSON(value['locationAndWorkplacePreference']),
        'profilePicture': ProfilePictureToJSON(value['profilePicture']),
        'phoneNumber': value['phoneNumber'],
        'globalTopSkills': value['globalTopSkills'],
        'privacyOptOut': value['privacyOptOut'],
        'globalSkills': value['globalSkills'],
        'functionalSkillIds': value['functionalSkillIds'],
        'industryExpertiseIds': value['industryExpertiseIds'],
        'strategyBackgrounds': value['strategyBackgrounds'] == null ? undefined : ((value['strategyBackgrounds'] as Array<any>).map((v) => StrategyBackgroundToJSON(v))),
        'willingnessToTravelInternationally': value['willingnessToTravelInternationally'],
    };
}

